export const typeOfUserRole = [
  { text: 'Super Admin', key: 'SUPER_ADMIN' },
  { text: 'Moderator', key: 'MODERATOR' },
];
